import { render, staticRenderFns } from "./EmbedSocial.vue?vue&type=template&id=068a899a"
import script from "./EmbedSocial.vue?vue&type=script&lang=js"
export * from "./EmbedSocial.vue?vue&type=script&lang=js"
import style0 from "./EmbedSocial.vue?vue&type=style&index=0&id=068a899a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports